import { Injectable } from '@angular/core';

export interface Hotness {
  label: string;
  flames: Array<string>;
}

// Array are filled out for ease-of-use witn *ngFor in Angular templates
const HOTNESS_EVENTS = {
  'custom-cold-event': {
    label: 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.HOTNESS_RATING.OPTIONS.NO_FLAME',
    flames: Array(0).fill(''),
  },
  'custom-chilly-event': {
    label: 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.HOTNESS_RATING.OPTIONS.1_FLAME',
    flames: Array(1).fill(''),
  },
  'custom-warm-event': {
    label: 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.HOTNESS_RATING.OPTIONS.2_FLAMES',
    flames: Array(2).fill(''),
  },
  'custom-hot-event': {
    label: 'AUTOMATIONS.EDITOR.TASKS.CREATE_BUSINESS_ACTIVITY.HOTNESS_RATING.OPTIONS.3_FLAMES',
    flames: Array(3).fill(''),
  },
};

@Injectable({ providedIn: 'root' })
export class ActivityHotnessService {
  listHotnessEvents(): [string, Hotness][] {
    return Object.entries(HOTNESS_EVENTS);
  }

  getHotness(value: string): Hotness {
    return HOTNESS_EVENTS[value] || null;
  }
}
